<template>
  <el-dialog
    title="GRB数据编辑窗口"
    :visible.sync="visible"
    @close="close">

    <el-form :inline="true" :model="GrbEditForm" label-position="right">
      <el-form-item label="GRB_ID">
        <el-input v-model="GrbEditForm.grb_id" autocomplete="off" style="width:290px;"></el-input>
      </el-form-item>
      <el-form-item label="触发时间(MJD)">
        <el-date-picker v-model="GrbEditForm.trigger_time" value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-ddTHH:mm:ss" type="datetime" style="width:260px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="触发时间(UTC)">
        <el-input v-model="GrbEditForm.trigger_time_utc" autocomplete="off" style="width:265px;"></el-input>
      </el-form-item>
      <el-form-item label="ra">
        <el-input v-model="GrbEditForm.ra" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item label="开始时间UTC">
        <el-date-picker v-model="GrbEditForm.start_utc" value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-ddTHH:mm:ss" type="datetime" style="width:260px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="dec">
        <el-input v-model="GrbEditForm.dec" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>      
      <el-form-item label="开始时间tt">
        <el-input v-model="GrbEditForm.start_tt" autocomplete="off" style="width:280px;"></el-input>
      </el-form-item>
      <el-form-item label="观测时长">
        <el-input v-model="GrbEditForm.duration" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item label="数据模式">
        <el-select style="width:290px;" v-model="GrbEditForm.data_mode"  filterable placeholder="数据模式">
              <el-option
                  v-for="item in datamode_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数据状态">
        <el-select style="width:260px;" v-model="GrbEditForm.status"  filterable placeholder="数据状态">
              <el-option
                  v-for="item in status_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Relate_ID">
        <el-input v-model="GrbEditForm.relate_id" autocomplete="off" style="width:285px;"></el-input>
      </el-form-item>        
      <el-form-item label="文件__ID">
        <el-input v-model="GrbEditForm.file_id" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item label="发布时间">
        <el-date-picker v-model="GrbEditForm.release_date" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width:290px;"></el-date-picker>
      </el-form-item>      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>

  </el-dialog>
</template>

<script>
import {datastatus_IE,DataMode} from '../common';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default(){
        return null
      },
    },
  },
  data() {
    return {
      GrbEditForm:{
        grb_id:'',
        trigger_time:'',
        trigger_time_utc:'',
        ra:'',
        dec:'',
        start_utc:'',
        start_tt:'',
        duration:'',
        data_mode:'',
        status:'',
        relate_id:'', 
        file_id:'', 
        release_date:'',    
        ind:'',   
      },
      status_list:datastatus_IE,
      datamode_list:DataMode,
      visible: false,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.GrbEditForm.grb_id = data.grb_id;
      this.GrbEditForm.trigger_time = data.trigger_time;
      this.GrbEditForm.trigger_time_utc = data.trigger_time_utc;
      this.GrbEditForm.ra = data.ra;
      this.GrbEditForm.dec = data.dec;
      this.GrbEditForm.start_utc = data.start_utc;
      this.GrbEditForm.start_tt = data.start_tt;
      this.GrbEditForm.duration = data.duration;
      this.GrbEditForm.data_mode = data.data_mode;
      this.GrbEditForm.status = data.status;
      // console.log('数据状态：',data.status);
      this.GrbEditForm.relate_id = data.relate_id;
      this.GrbEditForm.file_id = data.file_id;
      this.GrbEditForm.release_date = data.release_date;
      this.GrbEditForm.ind = data.ind;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      this.$emit('ok', {
        ...this.GrbEditForm,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
